import { GrowthbookFlag } from '../constants/feature-flags';
import { Locale } from '../enums/Locale';
import { useFeatureFlagIsOn } from '../hooks/feature-flags';
import { useLocalization } from '../providers/LocaleProvider';

const isB2BEnabled = (locale: Locale, withB2BEnabled?: boolean) =>
  locale === Locale.De_De_H24 ||
  (withB2BEnabled && [Locale.De_At, Locale.De_Ch, Locale.Fr_Ch].includes(locale));

export const useIsB2BEnabled = () => {
  const { locale } = useLocalization();
  const withB2BEnabled = useFeatureFlagIsOn(GrowthbookFlag.B2B);

  return isB2BEnabled(locale, withB2BEnabled);
};
